import * as Sentry from '@sentry/react';

const sentryDsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const sentryEnvironment =
  (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined)
  ?? import.meta.env.MODE;
const sentryRelease =
  import.meta.env.VITE_SENTRY_RELEASE as string | undefined;

export function initSentry(): void {
  Sentry.init({
    dsn: sentryDsn,
    enabled: Boolean(sentryDsn),
    environment: sentryEnvironment,
    integrations: [Sentry.browserTracingIntegration()],
    release: sentryRelease,
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1,
  });
}
